import React from 'react';
import PropTypes from 'prop-types';

import Icon from '@mui/material/Icon';
import IconButton from '@mui/material/IconButton';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Grid from '@mui/material/Grid';

import { Field } from '../Field/Field.js'
import { returnField } from '../../utils/formHelpers';

import { withTranslation } from 'react-i18next';

const handleDownload = (path, fileData) => {
  const fileName = fileData.fileName || 'download';

  const lower = fileName.toLowerCase();
  const isPdf = lower.endsWith('.pdf');
  const isImage = /\.(jpeg|jpg|gif|png|webp|bmp|svg)$/.test(lower);

  if (isPdf || isImage) {
    window.open(path, '_blank', 'noopener');
    return;
  }

  const link = document.createElement('a');
  link.href = path;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
};

const FirestoreFile = ({
  allowMultipleFiles,
  disabled,
  document,
  fileData,
  fileId,
  onDelete,
  path,
  setValue,
  showRole,
  t,
  thumbPath
}) => {
  const fileNamePath = document
    ? `${document}.fileList.${fileId}.fileName`
    : `fileList.${fileId}.fileName`;
  const fileRolePath = document
    ? `${document}.fileList.${fileId}.fileRole`
    : `fileList.${fileId}.fileRole`;

  // Fix freezing issue when 'fileName' is undefined
  if (fileData.fileName === undefined) {
    fileData.fileName = '';
  }

  return (
    <ListItem
      role={undefined}
      dense
      style={{ padding: '0px', paddingBottom: '10px', borderBottom: '1px dashed #ddd' }}
    >
      <ListItemText>
        <Grid
          style={{ textAlign: 'left' }}
          direction="row"
          spacing={0}
          container
          justifyContent="flex-start"
          alignItems="flex-end"
          alignContent="flex-start"
        >
          <Grid item xs={4} sm={2}>
            <div style={{ marginBottom: fileData.fileName.match(/\.(jpeg|jpg|gif|png)$/) !== null ? '' : '15px' }}>
              {fileData.fileName.match(/\.(jpeg|jpg|gif|png)$/) !== null &&
              <img
                style={{ width: '50px', height: '50px' }}
                src={thumbPath || path}
                alt=""
              />}
              {fileData.fileName.match(/\.(pdf)$/) !== null &&
              <span style={{ border: '1px solid #000', padding: '15px 10px 15px 10px' }}>PDF</span>
            }
              {fileData.fileName.match(/\.(doc|docx)$/) !== null &&
              <span style={{ border: '1px solid #000', padding: '15px 10px 15px 10px' }}>DOC</span>
            }
              {fileData.fileName.match(/\.(ppt|pptx)$/) !== null &&
              <span style={{ border: '1px solid #000', padding: '15px 10px 15px 10px' }}>PPT</span>
            }
              {fileData.fileName.match(/\.(xls|xlsx)$/) !== null &&
              <span style={{ border: '1px solid #000', padding: '15px 10px 15px 10px' }}>XLS</span>
            }
              {fileData.fileName.match(/\.(dwg)$/) !== null &&
              <span style={{ border: '1px solid #000', padding: '15px 10px 15px 10px' }}>DWG</span>
            }
            </div>
          </Grid>
          {allowMultipleFiles &&
          <Grid item xs={8} sm={3}>
            {showRole
              ?
              <Field
                component={returnField('text')}
                disabled
                fullWidth
                name={fileRolePath}
                type="text"
                val={t(`fileManagement.${fileData.fileRole}`)}
              />
              :
              <Field
                component={returnField('select')}
                disabled={disabled}
                fullWidth
                label={t('fileManagement.type')}
                name={fileRolePath}
                required
                selOpts={['floorPlan', 'otherAttachment']}
                setValue={setValue}
                translateOptions
                type="text"
                value={fileData.fileRole}
              />
            }
          </Grid>
        }
          <Grid item xs={allowMultipleFiles ? 6 : 4} sm={allowMultipleFiles ? 5 : 8}>
            <Field
              name={fileNamePath}
              val={fileData.fileName}
              component={returnField('text')}
              disabled
              type="text"
              fullWidth
            />
          </Grid>
          <Grid item xs={allowMultipleFiles ? 3 : 2} sm={1}>
            <IconButton aria-label="Open" onClick={() => handleDownload(path, fileData)} size="large">
              <Icon>get_app</Icon>
            </IconButton>
          </Grid>
          <Grid item xs={allowMultipleFiles ? 3 : 2} sm={1}>
            {!disabled &&
              <IconButton
                aria-label="Delete"
                onClick={() => onDelete(fileData.fileName)}
                size="large">
                <Icon>delete</Icon>
              </IconButton>
            }
          </Grid>
        </Grid>
      </ListItemText>
    </ListItem>
  );
};


FirestoreFile.propTypes = {
  allowMultipleFiles: PropTypes.bool,
  disabled: PropTypes.bool,
  document: PropTypes.string,
  fileData: PropTypes.object.isRequired,
  fileId: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired,
  path: PropTypes.string.isRequired,
  thumbPath: PropTypes.string
};

export default withTranslation('translations')(FirestoreFile);
